export default "/_next/static/images/4b2555b4ac24a9e6b29131b5e4d73c95.png";